import { render, staticRenderFns } from "./AddonYoutubeUpload.vue?vue&type=template&id=2a64bde0&"
import script from "./AddonYoutubeUpload.vue?vue&type=script&lang=js&"
export * from "./AddonYoutubeUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports